export enum PLANS {
  PAY_AS_YOU_GO = 'payg',
}
